<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Vendor Request</h1>
    </div>

    <!-- Breadcrumbs -->
    <div style="padding: 10px; background-color: #F2F2F2">
      <router-link to="/dashboard">Dashboard</router-link>
      /
      <b>Loyalty Point System</b>
      /
      <b>Vendor List</b>
    </div>
    <!-- End of breadcrumbs -->

    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Active -->
        <div class="card text-left">
          <div class="card-body">
            <div class="table-responsive">
              <table
                id="vendor_tbl"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Company Name</th>
                    <th>Starting Period</th>
                    <th>Product & Services Request</th>
                    <th>Company Details Request</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(list, index) in lists" :key="index">
                    <td>{{ index + 1 }}</td>
                    <td>{{ list.company_name }}</td>
                    <td>{{ list.starting_period }}</td>
                    <td>{{ list.product_request }}</td>
                    <td>{{ list.detail_request }}</td>
                    <td>
                      <router-link
                        :to="productRequest(list.vendor_id)"
                        type="button"
                        class="btn btn-primary btn-rounded btn-block"
                        >View Product Request</router-link
                      >

                      <router-link
                        :to="companyRequest(list.vendor_id)"
                        type="button"
                        class="btn btn-primary btn-rounded btn-block"
                        >View Company Request</router-link
                      >

                      <router-link
                        :to="{
                          name: 'vendor-redeem-list',
                          params: { id: list.vendor_id }
                        }"
                        type="button"
                        class="btn btn-primary btn-rounded btn-block"
                        >View Redeem List</router-link
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";

export default {
  name: "vendor-view",
  components: {},

  data() {
    return {
      lists: []
    };
  },

  methods: {
    async loadEntity() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;
        try {
          let result = await axios.get(axios.lpsURL + "/vendor/list", {
            headers: {
              Authorization: "Bearer " + token
            }
          });
          this.lists = result.data.lists;
          console.log(JSON.stringify(result.data.lists));
        } catch (error) {
          console.log(error);
        }
      }
    },

    productRequest(id) {
      return "/lps/vendor/product/" + id;
    },

    companyRequest(id) {
      return "/lps/vendor/company/" + id;
    },

    killDatatable() {
      $("#companies_tbl")
        .DataTable()
        .destroy();
    },

    createDatatable() {
      $("#vendor_tbl").DataTable({
        dom: "Bfrtip",
        pageLength: 5,
        lengthMenu: [
          [5, 10, 25, 50, -1],
          ["5 rows", "10 rows", "25 rows", "50 rows", "Show all"]
        ],
        buttons: [
          {
            extend: "excelHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4]
            }
          },
          {
            extend: "pdfHtml5",
            exportOptions: {
              columns: [0, 1, 2, 3, 4]
            }
          }
        ]
      });
    }
  },

  async created() {
    await this.loadEntity();
    this.createDatatable();
  },

  mounted() {}
};
</script>
